import { Component, ElementRef, Inject, PLATFORM_ID, QueryList, ViewChildren } from '@angular/core';
import { debounceTime, Subscription, tap } from 'rxjs';
import { AsyncPipe, isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ProductCardComponent } from '../components/product-card/product-card.component';
import { CategoryPageAbstract } from '../../common/category-page.abstract';
import { ObserverDirective } from 'src/app/shared/directives/observer/observer.directive';
import { ScrollListDirective } from 'src/app/shared/directives/scroll-list/scroll-list.directive';
import { ScrollItemDirective } from 'src/app/shared/directives/scroll-list/scroll-item.directive';
import { ObserverService } from '../../../shared/services/observer/observer.service';
import { VisibilityState } from '../../../shared/services/observer/visibility-state.interface';
import { UIMenuItemDto } from '../../../shared/interfaces/ui-menu-item-dto.interface';

@Component({
  selector: 'app-fresh-category-page',
  templateUrl: './fresh-category-page.component.html',
  styleUrls: ['./fresh-category-page.component.scss'],
  standalone: true,
  providers: [
    ObserverService
  ],
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    RouterOutlet,
    ProductCardComponent,
    ObserverDirective,
    ScrollListDirective,
    ScrollItemDirective,
  ]
})
export class FreshCategoryPageComponent extends CategoryPageAbstract {
  constructor (
    private observer: ObserverService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {super()}

  @ViewChildren('productCard') productCards!: QueryList<ElementRef<HTMLDivElement>>;

  private subscriptions: Subscription[] = [];
  visibilityMap = new Map<string, boolean>();

  override ngAfterViewInit () {
    super.ngAfterViewInit();

    if (!isPlatformBrowser(this.platformId)) {return}
    this.items$ = this.items$.pipe(
      debounceTime(50),
      tap(items => {
        if(!items){return}
        setTimeout(() => {
          this.observeCards(items);
        })
      })
    )
  }

  observeCards(items: Map<string, UIMenuItemDto[]>){
    let index = 0;

    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];

    items.forEach(category => {
      category.forEach( item => {
        const elementRef = this.productCards.get(index);
        if(!elementRef){return}

        const subscription = this.observer.observe(elementRef.nativeElement).subscribe((state: VisibilityState) => {
          this.visibilityMap.set(item.uniqKey, state.isVisible);
        });

        this.subscriptions.push(subscription);
        index++
      })
    })
  }
}
